/**
 * Pulls in the assessment node data and mounts React.js application.
 */
import React from 'react';
import ReactDOM from 'react-dom';

import Wheel from './Wheel';

require('isomorphic-fetch');

(() => {
  /* global drupalSettings */
  const wheelAspects = drupalSettings.wheel.aspects;
  ReactDOM.render(
    <Wheel wheelAspects={wheelAspects} />,
    document.getElementById('wheel-app'),
  );
})();



// WEBPACK FOOTER //
// js/src/wheel/App.js